<template>
  <span class="ui-icon-base component" v-on="$listeners">
    <component
      :is="iconName"
      :width="width"
      :height="height"
      :color="color">
    </component>
  </span>
</template>

<script>
  import write from './write'
  import moon from './moon'
  import done from './done'
  import arrowDown from './arrowDown'
  import sort from './sort'
  import sortDown from './sortDown'
  import sortUp from './sortUp'
  import loader from './loader'
  import melodie from './melodieLogo'
  import play from './play'

  export default {
    name: 'UiIconBase',
    props: {
      iconName: {
        type: String,
        default: 'moon'
      },
      width: {
        type: String,
        default: '18px'
      },
      height: {
        type: String,
        default: '18px'
      },
      color: {
        type: String,
        default: 'currentColor'
      },
      stroke: {
        type: String,
        default: '1px'
      }
    },

    components: {
      write,
      moon,
      play,
      done,
      arrowDown,
      sort,
      sortDown,
      sortUp,
      loader,
      melodie
    }
  }
</script>

<style lang="scss" scoped>
  .ui-icon-base.component {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/icons/UiBaseIcon.vue